import {Icon} from '@wandb/components';
import React from 'react';
import TimeAgo from 'react-timeago';

import {type SourceNotebookQuery} from '../../../../generated/graphql';

export function CreateNotebookOption() {
  return (
    <div className="flex items-center gap-8">
      <Icon icon="add-new" />
      <div>New notebook</div>
    </div>
  );
}

type Author = NonNullable<
  NonNullable<SourceNotebookQuery['project']>['notebooks']
>['edges'][number]['node']['author'];

type SourceNotebookOptionProps = {
  author: Author;
  name: string;
  lastUpdated: string;
};

export function SourceNotebookOption({
  author,
  name,
  lastUpdated,
}: SourceNotebookOptionProps) {
  return (
    <div className="flex gap-x-8">
      <Icon icon="notebook" size="xl" />
      <div className="flex flex-col">
        <div>{name}</div>
        <div className="text-sm text-wb-text-tertiary">
          {author?.name ?? ''}

          {lastUpdated && (
            <>
              {'・Last updated '}
              <TimeAgo date={lastUpdated} />
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export function SourceNotebookSingleValue({name}: {name: string}) {
  return (
    <div className="flex gap-x-8">
      <Icon icon="notebook" size="xl" />
      <div>{name}</div>
    </div>
  );
}
